import * as A from './actions';
import * as R from 'ramda';
import { isHttpError, mapInternalError, isCancelation } from '../../services/utils/result.utils';
var initialState = {
    items: [],
    filter: {},
};
export var setFilter = R.curry(function (filter, state) { return R.assoc('filter', filter, state); });
export var setItems = R.curry(function (items, state) { return R.assoc('items', items, state); });
var prepareError = function (err) {
    return !err || isCancelation(err) ? null : isHttpError(err) ? err : mapInternalError('', err);
};
export var setError = R.curry(function (err, state) { return R.assoc('error', prepareError(err), state); });
export var setLoading = R.curry(function (isLoading, state) {
    return R.assoc('isLoading', isLoading, state);
});
export var processesReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case A.LOAD_PROCESSES:
            // @ts-ignore
            return R.pipe(setFilter(action.payload.params), setError(''), setLoading(true))(state);
        case A.LOAD_PROCESSES_SUCCESS:
            // @ts-ignore
            return R.pipe(setItems(action.payload.items), setLoading(false))(state);
        case A.START_PROCESS_BY_ID:
        case A.START_PROCESS_BY_KEY:
        case A.START_PROCESS_BY_APP:
            // @ts-ignore
            return R.pipe(setError(''), setLoading(true))(state);
        case A.START_PROCESS_BY_ID_SUCCESS:
        case A.START_PROCESS_BY_KEY_SUCCESS:
        case A.START_PROCESS_BY_APP_SUCCESS:
            return setLoading(false, state);
        case A.LOAD_PROCESSES_ERROR:
        case A.START_PROCESS_BY_ID_ERROR:
        case A.START_PROCESS_BY_KEY_ERROR:
        case A.START_PROCESS_BY_APP_ERROR:
            return R.pipe(setError(action.payload.error), setLoading(false))(state);
        default:
            return state.error ? setError('', state) : state;
    }
};
//# sourceMappingURL=reducer.js.map